export enum SchoolId {
  MARKETING_DIGITAL = 'P_DIGMKT_SCH',
  PROGRAMICION_DE_APPS = 'P_MOBDEV_SCH',
  DISENO_DIGITAL = 'P_DESIGN_SCH',
  NEGOCIOS_DIGITALES = 'P_DIGBUS_SCH',
  DESARROLLO_WEB = 'P_WEBDEV_SCH',
  CLOUD_COMPUTING = 'P_CLOUD_IT_SCH',
  DESARROLLO_PROFESIONAL = 'P_DESPROF_SCH',
  FIU = 'P_FIU_SCH',
  CRIPTOMONEDAS = 'P_CRYPTO_SCH',
}
